import ScopeConstants from "constants/ScopeConstants"
import { FormActionReducer } from "@gman/gman-redux"

export const CostCodeGroupsAllReducer = (
  state = {
    ...FormActionReducer.defaultPageState(),
    ...FormActionReducer.defaultSearchOptions("Name"),
    ...FormActionReducer.defaultRecordState(),
    ...FormActionReducer.defaultTabs()
  },
  action) => {

  if (action.scope === ScopeConstants.COST_CODE_GROUP_ALL) {
    return FormActionReducer.reduce(action, state)
  }

  return state
}